/**
 * Admin › Feature votes: every item with its vote counts. No names. Logic
 * lives in `~/lib/server/feature-votes`.
 *
 * Aliases: admin feature votes, feature vote counts, roadmap demand
 */

import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";

import { permissionMiddleware } from "~/lib/permission-middleware";

export const getAdminFeatureVoteCountsFn = createServerFn({ method: "POST" })
  .middleware([permissionMiddleware("feature-votes:read")])
  .handler(async () => {
    const { listFeatureVoteCounts } =
      await import("~/lib/server/feature-votes");
    return listFeatureVoteCounts({ now: new Date() });
  });

export const adminFeatureVoteCountsQueryOptions = queryOptions({
  queryKey: ["admin-feature-votes", "counts"] as const,
  queryFn: () => getAdminFeatureVoteCountsFn(),
});
